import {useEffect} from "react";
import {useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {getUserVenues} from "@/store/user-info/action";
import {RootState, useAppDispatch} from "@/store";
import BreadcrumbLayout from "@/components/common/CustomLayout/BreadcrumbLayout";
import IncomeStatementFilter from "@/pages/Report/IncomeStatementFilter";
import IncomeStatementResult from "@/pages/Report/IncomeStatementResult";
import './index.css'
import {getIncomeStatementBookings, getIncomeSummary} from "@/store/income-statement/action";
import useCustomPaging from "@/hooks/useCustomPaging";

const IncomeStatement = () => {
  const dispatch = useAppDispatch()
  const [filters, setFilters] = useSearchParams()
  const venues = useSelector((state: RootState) => state.userInfo.state.venues)
  const [,,handlePageNumberChange] = useCustomPaging()
  
  const handleUpdate = (params: any) => {
    setFilters(params)
    dispatch(getIncomeSummary({ params }))
    dispatch(getIncomeStatementBookings({ params }))
  }

  const handlePageChange = (page: number) => {
    const params = {
      venueId: filters.get('venueId'), 
      startDate: filters.get('startDate'), 
      endDate: filters.get('endDate'),
      page,
    }
    dispatch(getIncomeStatementBookings(
      { params }
    ))
    handlePageNumberChange(page)
  }
  
  useEffect(() => {
    dispatch(getUserVenues({}))
  }, [])
  
  return (
    <BreadcrumbLayout>
      <div className="w-full flex flex-col gap-7">
        <div className="page-title">Income Statement</div>
        {
          venues.length ?
          <div className="report-wrapper">
            <div>
              <IncomeStatementFilter
                handleUpdate={handleUpdate} />
            </div>
            <IncomeStatementResult 
              handlePageChange={handlePageChange}
            />
          </div> : <></>
        }
      </div>
    </BreadcrumbLayout>
  )
  
}
export default IncomeStatement;